// AB - Clinically-Proven Results PDP: Convert custom trigger on scroll + lock visibility once revealed
(function() {
  var hasScrolled = false;
  var locked = false;

  function triggerClinicalResults() {
    console.log("Trigger - Resultados Clínicamente Probados");
    window._conv_q = window._conv_q || [];
    window._conv_q.push({
      what: "triggerLocation",
      params: {
        locationId: "1004149744"
      }
    });
  }

  function lockVisible() {
    if (locked) return;
    locked = true;
    document.documentElement.classList.add('ab-clinical-results-active');
    if (observer) observer.disconnect();
  }

  function checkRevealed() {
    var el = document.querySelector('.ab-clinical-results-wrapper');
    if (!el) return;
    var display = window.getComputedStyle(el).display;
    if (display !== 'none') lockVisible();
  }

  var observer = new MutationObserver(checkRevealed);
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['style', 'class']
  });

  function onFirstScroll() {
    hasScrolled = true;
    triggerClinicalResults();
    window.removeEventListener('scroll', onFirstScroll);
    setTimeout(checkRevealed, 500);
    setTimeout(checkRevealed, 1500);
  }

  window.addEventListener('scroll', onFirstScroll, { passive: true });

  document.addEventListener('variant::changed', function() {
    if (!hasScrolled || locked) return;
    triggerClinicalResults();
  }, true);

  document.addEventListener('update::product_linking', function() {
    if (!hasScrolled) return;
    triggerClinicalResults();
    setTimeout(checkRevealed, 500);
    setTimeout(checkRevealed, 1500);
  });
})();

document.addEventListener('DOMContentLoaded', () => {
  function calcularPorciones(container) {
    const itemPorciones = document.querySelector('.item-porciones');
    const spanResultado = document.querySelector('.item-porciones > p > span');
    if (!itemPorciones || !spanResultado) return;

    const inputCantidad = container.querySelector('input[name="custom-quantity"]');
    if (!inputCantidad) return;

    const valorInput = Number(inputCantidad.value);
    const valorPorciones = Number(itemPorciones.getAttribute('value'));
    const resultado = valorInput * valorPorciones;
    spanResultado.textContent = resultado;
  }

  setTimeout(function() {
    document.body.addEventListener('click', (event) => {
      const quantityBreak = event.target.closest('.quantity-break');
      if (quantityBreak) {
        calcularPorciones(quantityBreak);
      }
    });
  }, 1000);
});